/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_View_AllInputs */

const en_notifications_view_all = /** @type {(inputs: Notifications_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all notifications`)
};

const pt_br2_notifications_view_all = /** @type {(inputs: Notifications_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas as notificações`)
};

/**
* | output |
* | --- |
* | "View all notifications" |
*
* @param {Notifications_View_AllInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_view_all = /** @type {((inputs?: Notifications_View_AllInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_View_AllInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_view_all(inputs)
	return pt_br2_notifications_view_all(inputs)
});